import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ProgressBarModule } from '@openng/optimus-ui/progressbar';
import { LoadingService } from '@padspin/ui-header';
import { toSignal } from '@angular/core/rxjs-interop';

/** Display the global loading bar in the header when the app is loading. */
@Component({
  selector: 'padspin-header-loading-bar',
  imports: [ProgressBarModule],
  template: `
    @if (isLoading()) {
      <p-progressbar
        mode="indeterminate"
        class="progress-bar"
        [style]="{ height: '4px' }"
      ></p-progressbar>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderLoadingBarComponent {
  private readonly isLoadingService = inject(LoadingService);
  protected isLoading = toSignal(this.isLoadingService.isLoading());
}
